import React from 'react';
import ReactDOM from 'react-dom';
import "bootstrap/dist/css/bootstrap.css"
import './index.css';
import './theme.css';
import './interceptorErrores'; // deja los errores de red legibles en todos los catch
import Routes from './components/Routes'
import '@fortawesome/fontawesome-free/css/all.min.css'; // ⬅️ Importas el CSS aquí

let tema = localStorage.getItem("tema")

if(tema == "white-content"){
  document.body.classList.add("white-content")
}

ReactDOM.render(
  <React.StrictMode>
    <Routes />
  </React.StrictMode>,
  document.getElementById('root')
);

